import { SET_VALUE_ARRAY_SIZE_LIMIT } from '../constants';
import { isNotEmptyString } from '../utils/is-not-empty-string';

export type MultiCheckboxSetPublicValue = string[];

export const validateMultiCheckboxSetValue = (
	value: unknown,
): value is MultiCheckboxSetPublicValue =>
	Array.isArray(value) &&
	value.length <= SET_VALUE_ARRAY_SIZE_LIMIT &&
	value.every(isNotEmptyString);
